import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import DatabaseFunctions from '../../components/users/DatabaseFunctions'
import { uploadFileData, dbupload, getCurrentUser, getTeams } from '../../actions/userActions'
import {
    getDbJobsSiteWide,
    getDbJobHistorySiteWide,
    getDataSources,
    getDatabaseJobFiles,
    downloadDatabaseJobFile,
    selfServiceChangeFilesPage,
    selfServiceChangeJobsPage,
    selfServiceChangeHistoriesPage,
    openEditNewWizardFile
} from '../../actions/dbFunctionsActions'
import { showPopup } from "../../actions/uiActions"
import { doesThisUserHaveThisAuthorization } from '../../components/utilities/helperFunctions'

function DatabaseFunctionsContainer(props) {
    const [allowedRoles] = useState(['IEAdmin', 'ClientAdmin'])
    const [hasSpecialPermission, setHasSpecialPermission] = useState(false)
    const [performingJob, setPerformingJob] = useState(false)

    useEffect(() => {
        if (props.jobs.length === 0) {
            props.getDbJobsSiteWide(-1)
        }
        if (props.histories.length === 0) {
            props.getDbJobHistorySiteWide(-1)
        }
        if (props.globalFiles.length === 0) {
            props.getDatabaseJobFiles()
        }
        if (props.teamList.length === 0) {
            props.getTeams()
        }
    }, [])

    useEffect(() => {
        if (performingJob && !props.performingJob) {
            props.getDbJobHistorySiteWide(-1)
        }
        setPerformingJob(props.performingJob)
    }, [props.performingJob])

    useEffect(() => {
        if (props.currentUser !== null) {
            if (props.currentUser["applicationUserClaims"] !== null) {
                let applicationUserClaims = props.currentUser["applicationUserClaims"]
                applicationUserClaims.forEach(a => {
                    if (a["claimValue"] === "DatabaseFunctions") {
                        setHasSpecialPermission(true)
                    }
                })
            }
        }
    }, [props.currentUser])

    if (props.currentUser === null) {
        props.getCurrentUser(props.userID)
    }

    if (allowedRoles.includes(props.role) || hasSpecialPermission) {
        return <div className="main">
            <DatabaseFunctions
                uploadFileData={props.uploadFileData}
                dbupload={props.dbupload}
                dbList={props.dbList}
                showPopup={props.showPopup}
                jobs={props.jobs}
                histories={props.histories}
                getDataSources={props.getDataSources}
                globalFiles={props.globalFiles}
                downloadFile={props.downloadDatabaseJobFile}
                role={props.role}
                performingJob={props.performingJob}
                jobProgressId={props.jobProgressId}
                currentJobProgress={props.currentJobProgress}
                currentJobTotalParts={props.currentJobTotalParts}
                selfServiceChangeFilesPage={props.selfServiceChangeFilesPage}
                selfServiceChangeJobsPage={props.selfServiceChangeJobsPage}
                selfServiceChangeHistoriesPage={props.selfServiceChangeHistoriesPage}
                openEditNewWizardFile={props.openEditNewWizardFile} />
        </div>
    } else {
        return null
    }
}

function mapDispatchToProps(dispatch) {
    return {
        ...bindActionCreators({ uploadFileData, dbupload, showPopup, getDbJobsSiteWide, getDbJobHistorySiteWide, getDataSources, getDatabaseJobFiles, downloadDatabaseJobFile, doesThisUserHaveThisAuthorization, getCurrentUser, getTeams, selfServiceChangeFilesPage, selfServiceChangeJobsPage, selfServiceChangeHistoriesPage, openEditNewWizardFile }, dispatch)
    }
}

function mapStateToProps(state) {
    return {
        role: state.users.role,
        dbList: state.users.custDBList,
        jobs: state.selfServeJobs.jobs,
        histories: state.selfServeJobs.histories,
        globalFiles: state.selfServeJobs.globalFiles,
        performingJob: state.selfServeJobs.performingJob,
        jobProgressId: state.selfServeJobs.jobProgressId,
        currentJobProgress: state.selfServeJobs.currentJobProgress,
        currentJobTotalParts: state.selfServeJobs.currentJobTotalParts,
        currentUser: state.users.currentUser,
        userID: state.users.userID,
        teamList: state.users.teamList
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(DatabaseFunctionsContainer);